import { useEffect } from 'react';

import { useQuery } from '@tanstack/react-query';
import { useLocation, useNavigate } from 'react-router-dom';

import { getPartnerConfig, partnersQueries } from '@/api/partners.service';

import SESSION_TOKEN_SERVICE from '@/constants/SessionTokenService';

import EAppRoute from '@/types/appRoutes';

import { PartnerDto } from '@/generated-types';
import useCustomParams from '@/shared/hooks/useCustomParams';

const useInitializeApp = (): {
	isLoading: boolean;
	partnerData?: Required<PartnerDto>;
} => {
	const params = useCustomParams();

	const location = useLocation();
	const navigate = useNavigate();

	const { isLoading, error, data } = useQuery({
		queryKey: partnersQueries.partner.me.queryKey,
		queryFn: () => getPartnerConfig(params.partner as string),
		enabled: !!params.partner,
		retry: 0,
	});

	useEffect(() => {
		if (!error) {
			return;
		}

		navigate(`${EAppRoute.NotFound}${location.search}`, { replace: true });
	}, [error, navigate]);

	useEffect(() => {
		if (!data) {
			return;
		}

		if (process.env.DEFAULT_PARTNER === 'loanbud' && !data.isLoanbudPartner) {
			navigate(EAppRoute.NotFound);
			return;
		}

		SESSION_TOKEN_SERVICE.setLocalAccessToken(data.apiKey);
	}, [data]);

	return { isLoading, partnerData: data };
};

export default useInitializeApp;
